import R from 'ramda'

export const location2MultiPolygon = (l) => {
  const coordinates = R.path(["geometry", "coordinates"])
  const onlyOuterBounds = R.map(R.compose(R.init(), R.head()))
  return onlyOuterBounds(coordinates(l))
}

export const listOfLocation2MultiPolygon = (ls) => {
  return R.chain(location2MultiPolygon, ls)
}





/** WEBPACK FOOTER **
 ** ./app/utils/location2MultiPolygon.js
 **/